export default __webpack_public_path__ + "static/media/magnify.7c80fc70.svg";